

export const convert = (x: any, to: 'string' | 'boolean' | 'number' | any): [boolean, any?] => {

    if (to === 'string') {
        if (x !== null || x !== undefined) {
            return [true, x.toString()];
        }
    }
    else if (to === 'number') {
        if (typeof (x) === 'number') {
            return [true, x];
        }
        if (typeof (x) === 'boolean') {
            return [true, Number(x)];
        }
        const n = parseFloat(x);
        if (!isNaN(n)) return [true, n];
    }
    else if (to === 'boolean') {
        if (typeof (x) === 'boolean' || typeof (x) === 'number') {
            return [true, !!x];
        }
        const t = x.trim().toLowerCase();
        if (t === 'true') return [true, true];
        if (t === 'false') return [true, false];
        const n = parseFloat(x);
        if (!isNaN(n)) return [true, !!n];
    }
    else if (to === 'any') {
        return [true, x];
    }

    return [false];
};

export const tryConvert = (x: any, to: 'string' | 'boolean' | 'number' | any): any => {
    const [ok, result] = convert(x, to);
    return ok ? result : null;
};
